import momentTimeZone from "moment-timezone";
import dayjs from "dayjs";
import { formatDateRange } from '../../../helpers/helpers';
import moment from "moment/moment";

export const checkIsRestPlanModify = (request = {}) => {
    const { planGroupId } = request;
    if (!planGroupId) {
      return `annualLeavePlan.approvalRequest`;
    }

    return request?.firstPlanYn === 'Y' ? `annualLeavePlan.approvalRequest` : `annualLeavePlan.approvalRequestModify`;
};


/**
 * Render period information for rest plan
 * @param {Object} userData - User data containing start/end dates and times
 * @param {Function} t - Translation function
 * @returns {string} Formatted period string
 */
export function renderUserRestPeriod(userData, t) {
    const timezone = momentTimeZone.tz.guess();
    const diffHours = dayjs(userData.endDate).diff(dayjs(userData.startDate), 'hour');

    const formattedStartDate = momentTimeZone.tz(userData.startDate, timezone).format('YYYY-MM-DD');
    const formattedEndDate = momentTimeZone.tz(userData.endDate, timezone).format('YYYY-MM-DD');

    if (diffHours >= 24) {
        return `${formattedStartDate} ~ ${formattedEndDate}`;
    }

    if (userData.startTime || userData.endTime) {
        return formatDateRange(
            userData.startDate,
            userData.startTime,
            userData.endDate,
            userData.endTime,
            t,
            userData?.data?.row?.total || userData?.data?.ot || 0,
            moment(userData.endTime, 'HH:mm').isBefore(moment(userData.startTime, 'HH:mm'))
        )
    }

    return `${formattedStartDate} ~ ${formattedEndDate}`;
}